class AppMustUpgradeError extends Error {
  constructor({ config }) {
    super('AppMustUpgrade');
    this.mustUpgradeConfig = config;
  }
}

export default AppMustUpgradeError;
